import React from 'react'

export default ({ email }) => (
  <div className="mb-3 mt-8 lead">
    <p className="lead">You may not join waitlists or drop classes at this time.</p>
    <p className="lead">For more assistance, please get in touch with the your school's primary contact for this assignment period: <a href={`mailto:${email}`}>{email}</a></p>
  </div>
)


// WEBPACK FOOTER //
// ./src/components/rank/MessageAddDropIsClosed.js